export const TRAINING_TELEMETRY_HOST = {
  href: 'https://telemetry.seeq.com/training',
  label: 'training.seeq.com',
};

export const SUPPORT_LINK = 'https://telemetry.seeq.com/support-link/kb/latest/cloud';

export const GET_STARTED_WITH_SEEQ_LINK = `${SUPPORT_LINK}/get-started-with-seeq`;

export const APPLICATIONS_LINK = `${SUPPORT_LINK}/applications`;
